module.exports = __webpack_public_path__ + "static/ddd-f980c308870b1379c4ada5910e0a7c38.png";